<template>
  <div>
    <!-- 原材料  -->
    <el-table :data="qutaForm.listOfRawMaterials" border class="vg_mt_16" style="width: 100%" @selection-change="selectChange">
      <el-table-column align="center" label="序号" type="index"></el-table-column>
      <el-table-column align="center" label="物料编号" min-width="120" prop="mtrl_no">
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.listOfRawMaterials.' + scope.$index + '.mtrl_no'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input v-model.trim="scope.row.mtrl_no" clearable disabled maxlength="30" show-word-limit size="small"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="物料类型" min-width="100" prop="mtrl_type">
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.listOfRawMaterials.' + scope.$index + '.mtrl_type'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-select v-model="scope.row.mtrl_type" disabled size="small">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="物料名称" min-width="120" prop="mtrl_name">
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.listOfRawMaterials.' + scope.$index + '.mtrl_name'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-tooltip :content="scope.row.mtrl_name" class="item" effect="dark" placement="top-start">
              <el-input v-model.trim="scope.row.mtrl_name" clearable disabled maxlength="30" show-word-limit size="small"></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="物料规格" min-width="120" prop="mtrl_spec">
        <template slot="header">
          <span style="color: red">物料规格</span>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.listOfRawMaterials.' + scope.$index + '.mtrl_spec'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-tooltip :content="scope.row.mtrl_spec" class="item" effect="dark" placement="top-start">
              <el-input
                v-model="scope.row.mtrl_spec"
                :autosize="{ minRows: 1, maxRows: 4 }"
                clearable
                maxlength="50"
                show-word-limit
                size="small"
                type="textarea"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="部位" min-width="120" prop="quta_mtrl_part">
        <template slot="header">
          <span style="color: red">部位</span>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.listOfRawMaterials.' + scope.$index + '.quta_mtrl_part'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-tooltip :content="scope.row.quta_mtrl_part" class="item" effect="dark" placement="top-start">
              <el-input
                v-model="scope.row.quta_mtrl_part"
                :autosize="{ minRows: 1, maxRows: 4 }"
                clearable
                maxlength="50"
                show-word-limit
                size="small"
                type="textarea"
              ></el-input>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用量" min-width="140" prop="quta_mtrl_consume">
        <template slot="header">
          <span style="color: red">用量</span>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.listOfRawMaterials.' + scope.$index + '.quta_mtrl_consume'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="scope.row.quta_mtrl_consume"
              maxlength="15"
              show-word-limit
              size="small"
              @blur="scope.row.quta_mtrl_consume = helper.calcPrice(scope.row.quta_mtrl_consume, 4, 10000000000)"
              @change="() => getTotalPrice(999)"
              @input="
                scope.row.quta_mtrl_consume =
                  scope.row.quta_mtrl_consume
                    .replace(/^0+(\d)/, '$1')
                    .replace(/^\./, '0.')
                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''
              "
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="损耗比率" min-width="140" prop="quta_mtrl_lossrate">
        <template slot="header">
          <span style="color: red">损耗比率</span>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.listOfRawMaterials.' + scope.$index + '.quta_mtrl_lossrate'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input
              v-model="scope.row.quta_mtrl_lossrate"
              maxlength="15"
              show-word-limit
              size="small"
              @blur="scope.row.quta_mtrl_lossrate = helper.calcPrice(scope.row.quta_mtrl_lossrate, 4, 10000000000)"
              @change="() => getTotalPrice(999)"
              @input="
                scope.row.quta_mtrl_lossrate =
                  scope.row.quta_mtrl_lossrate
                    .replace(/^0+(\d)/, '$1')
                    .replace(/^\./, '0.')
                    .match(/^\d*(\.?\d{0,4})/g)[0] || ''
              "
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>

      <el-table-column align="center" label="含损耗用量" min-width="140" prop="quta_contain_lossrate">
        <template slot="header">
          <span style="color: red">含损耗用量</span>
        </template>
        <template v-slot="scope">
          <el-form-item
            :prop="'factoryList.' + formIndex + '.listOfRawMaterials.' + scope.$index + '.quta_contain_lossrate'"
            :rules="{ required: true, message: ' ', trigger: 'blur' }"
            label-width="0"
          >
            <el-input v-model="scope.row.quta_contain_lossrate" disabled maxlength="15" show-word-limit size="small"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" label="价格明细" min-width="140" show-overflow-tooltip>
        <template slot="header">
          <span style="color: red">价格明细</span>
        </template>
        <template v-slot="scope">
          <el-form-item label-width="0">
            <el-row>
              <el-col :md="12"><span>复合费用</span></el-col>
              <el-col :md="12">
                <el-input
                  v-model="scope.row.mtrl_comp_addcost"
                  maxlength="7"
                  placeholder="暂无复合费用"
                  show-word-limit
                  @change="getTotalPrice"
                  @input="val => (scope.row.mtrl_comp_addcost = formatNumberOver100(val))"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label-width="0">
            <el-row>
              <el-col :md="12"><span>印花费用</span></el-col>
              <el-col :md="12">
                <el-input
                  v-model="scope.row.mtrl_prit_addcost"
                  maxlength="7"
                  placeholder="暂无印花费用"
                  show-word-limit
                  @change="getTotalPrice"
                  @input="val => (scope.row.mtrl_prit_addcost = formatNumberOver100(val))"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-for="(value, key, index) in scope.row.mtrb_bom_mater || {}" :key="key + index" label-width="0">
            <el-row>
              <el-col :md="12">
                <span>{{ key }}</span>
              </el-col>
              <el-col :md="12">
                <el-input
                  v-model="scope.row.mtrb_bom_mater[key]"
                  :placeholder="`暂无${key}费用`"
                  maxlength="7"
                  show-word-limit
                  @change="getTotalPrice"
                  @input="val => (scope.row.mtrb_bom_mater[key] = formatNumberOver100(val))"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="right" label="DYJ报价" min-width="120" prop="dyjsum_money" show-overflow-tooltip>
        <template v-slot="scope">
          <el-form-item :prop="'factoryList.' + formIndex + '.listOfRawMaterials.' + scope.$index + '.dyjsum_money'" label-width="0">
            <el-input v-model="scope.row.dyjsum_money" disabled size="small"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="right" label="采购部报价" min-width="120" prop="purc_price" show-overflow-tooltip></el-table-column>
    </el-table>

    <div class="vd_price_toatl">
      <div class="vd_price">
        <h3><span>总计:</span></h3>
        <h2 class="vg_ml_8" style="color: #c70e0e">
          <span>{{ c_totalPrice }}</span>
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import requImport from './requImport2.vue';
import { BigNumber } from 'bignumber.js';
import { formatNumberOver100, keep4Decimal } from '@assets/js/regExUtil';

export default {
  name: 'QutaRawMater',
  components: {
    requImport
  },
  props: {
    qutaForm: {
      type: Object,
      required: true,
      default() {
        return {
          listOfRawMaterials: []
        };
      }
    },
    formIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      mulTab: [],
      total: 0,
      dialogVisible: false,
      typeList: [
        { value: 0, label: '原面料' },
        { value: 3, label: '加工面料' }
      ],
      totalPrice: 0
    };
  },
  created() {
    this.initData();
  },
  computed: {
    c_totalPrice() {
      if (this.totalPrice) return this.totalPrice;
      let sum = this.qutaForm.listOfRawMaterials.reduce((accumulator, currentItem) => {
        return accumulator.plus(new BigNumber(currentItem.purc_price || 0));
      }, new BigNumber(0));
      return sum.toFixed(4);
    }
  },
  methods: {
    formatNumberOver100,
    keep4Decimal,
    initData() {},
    selectChange(selection) {
      this.mulTab = selection;
    },
    getTotalPrice(flag) {
      if (flag === 999) {
        this.qutaForm.listOfRawMaterials.forEach(item => {
          item.quta_contain_lossrate = this.helper.haveSix(item.quta_mtrl_lossrate * item.quta_mtrl_consume);
        });
      }
      setTimeout(() => {
        let num = new BigNumber(0);
        if (this.qutaForm.listOfRawMaterials) {
          this.qutaForm.listOfRawMaterials.forEach(item => {
            let temp = 0;
            for (const key in item.mtrb_bom_mater) {
              temp += Number(item.mtrb_bom_mater[key]);
            }
            item.purc_price = new BigNumber(temp)
              .plus(item.mtrl_comp_addcost || 0)
              .plus(item.mtrl_prit_addcost || 0)
              .times(item.quta_contain_lossrate || 0)
              .toFixed(4, 1);
            num = num.plus(item.purc_price);
          });
        }
        num = num.toNumber();
        this.totalPrice = this.helper.haveFour(num, 4);
      }, 500);
    }
  }
};
</script>

<style scoped>
.vd_price_toatl {
  /* display: flex;
  justify-content: space-between; */
  padding: 10px 20px;
}

.vd_price {
  display: flex;
  justify-content: flex-end;
}
</style>
